import { render, staticRenderFns } from "./agreedGoods.vue?vue&type=template&id=3aca05d6&scoped=true"
import script from "./agreedGoods.vue?vue&type=script&lang=js"
export * from "./agreedGoods.vue?vue&type=script&lang=js"
import style0 from "./agreedGoods.vue?vue&type=style&index=0&id=3aca05d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aca05d6",
  null
  
)

export default component.exports